const messages = {
  seasons: {
    all: "All sesong",
    summer: "Sommer",
    winter: "Vinter",
    general: "Generelt",
  },
  offer:
    "Vi utvider jevnlig <br />tilbudene våre for deg! <br /><br />Vi informerer deg om nye kurs i innboksen din.",
  summary: {
    congratulations: "GRATULERER – DU HAR FULLFØRT EKSpertise PÅ",
    participation:
      "Du har fullført Online Training for Transporter All-Season-dekk.",
    certificate:
      "Certifikatet ditt sendes til deg på e-post, eller du kan laste det ned direkte som PDF her:",
    send: "Last ned certifikat",
  },
  online: {
    title: "Våre nettkurs",
    desc: "Skaff deg ekspertkunnskap og ved vellykket fullføring av de respektive testene for kurset ditt personlige deltakelsesbevis samt 40 ekstrapoeng til premieklubben første gang",
    content:
      "Utforsk våre noverande nettkurs og delta direkte på plattformen her:",
    categories: {
      title: "Nettkurs",
      description:
        "Hold deg foran med kunnskap: Skaff eksklusiv ekspertise for deg og teamet ditt med våre kurs. Enten det er våre nettkurs som du kan delta i direkte på plattformen, våre kurs og praktiske seminarer på Bridgestone Training Center, eller eksterne kurs som du kan redusere kostnadene for med premiepoengene dine.",
      general: {
        title: "Generelt",
        subtitle: "Nettkurs: Generelt",
        description:
          "Utforsk de nyeste teknologiene, viktige utviklinger i dekkindustrien og tips til salgsargumentene dine.",
        subdesription:
          "Skaff ekspertkunnskap og ved vellykket fullføring av de respektive kurstestene ditt personlige deltakelsesbevis samt en engangbonus på 40 ekstrapoeng til premieklubben.",
      },
      product: {
        title: "Produkter",
        subtitle: "Nettkurs: Produkter",
        description:
          "Fordyp Bridgestone- og Firestone-produktkompetansen din for vellykket salg med våre kompakte kursvideoer.",
        subdesription:
          "Skaff ekspertkunnskap og ved vellykket fullføring av de respektive kurstestene ditt personlige deltakelsesbevis samt en engangbonus på 40 ekstrapoeng til premieklubben.",
      },
    },
  },
  lectures: {
    title: "Bridgestone-kurs",
    desc: "Utvid ekspertisen din og bestill våre kurs og intensive kurs for deg og teamet ditt. Du har mulighet til å delta i kursene på Bridgestone Competence and Training Center i Dietzenbach (nær Frankfurt am Main) eller for utvalgte kurs få dem gjennomført hos deg. Du kan bruke bonuspoengene dine på kurs og dermed dekke kostnadene helt eller delvis med poengene dine.",
    content: "Utforsk våre noverande kurs og send en bestillingsforespørsel:",
  },
  singleLecture: {
    registerForm: {
      title: "Kursinnhold",
      inquiry: "Forespørsel",
      interested: "Jeg er interessert i kurset",
      participantsNr: "Antall deltakere",
      pointsFromBalance: "Jeg vil bruke poeng fra punktbalansen min.",
      reduction: "Dette tilsvarer en kostnadsreduksjon på {points} euro.",
      request: "Send forespørsel",
    },
    success: {
      thanks: "Takk",
      title: "Forespørselen din er sendt til kursteamet.",
      feedbackTime:
        "Du får svar innen 14 dager for å avklare alle detaljer.",
      points:
        "Bonuspoengene brukt på<br /><strong>{points}</strong> poeng er trukket fra<br />punktkontoen din.",
      refund:
        "Hvis kurset ikkje gjennomføres, krediteres poengene selvfølgelig tilbake til deg.",
      queries: "For spørsmål, vennligst kontakt:",
    },
    index: {
      costs: "Kostnader og deltakelsesinformasjon",
      duration: "Varighet: {duration}",
      cost: "Kostnader {cost}: {price} euro",
      participantsNr: "Deltakere: min. {min} – maks. {max} personer",
    },
  },
  index: {
    title: "Kurs og opplæring",
    desc: "Fordel med kunnskap: Skaff eksklusiv fagkunnskap for deg og teamet ditt med våre kurstilbud. Enten med våre nettkurs som du kan delta i direkte på plattformen, med våre kurs og praktiske seminarer på Bridgestone opplæringssenter eller med eksterne kurs som du kan redusere kostnadene for med premiepoengene dine.",
    online: {
      title: "Nettkurs",
      desc: "Delta direkte på plattformen og skaff {points} poeng til premieklubben.",
    },
    lectures: {
      title: "Kurs",
      desc: "Kurs av høy kvalitet på vårt opplæringssenter eller hos deg.",
    },
    external: {
      title: "Eksterne kurs",
      desc: "Bruk bonuspoeng på tilbud fra tredjepartsleverandører og reduser kostnadene.",
    },
  },
  single: {
    done: "Kurs fullført.",
    doneDownloadCertificate: "Kurs fullført. Last ned certifikat.",
  },
  certificate: {
    header: "SERTIFIKAT",
    atCourse: "har deltatt i",
    takePart: "kurs.",
    contains: "KURSINNHOLD",
    country: "Storbritannia",
  },
};

export default {
  messages,
};
